const vip = {
  namespaced: true,
  state: {
    switch: false,
    day: 0,
    level: 1
  },
  mutations: {
    set_vip_switch(state, val) {
      state.switch = val
    },
    set_vip_level(state, val) {
      state.level = val
    },
    set_vip_day(state, val) {
      state.day = val
    }
  }
}


export default vip



// WEBPACK FOOTER //
// ./src/vuex/modules/vip.js